function initFeaturedSlider(slider) {
  if (!slider) return;
  if (slider.classList.contains('splide--featured-initialized')) return;

  const splide = new Splide(slider, {
    type: 'loop',
    perPage: 1,
    perMove: 1,
    gap: '20px',
    pagination: false,
    arrows: true,
    autoplay: true,
       interval: 4000,
       speed: 800,
    drag: true,
  });

  const bar = slider.querySelector('.my-carousel-progress-bar');

  if (bar) {
    splide.on('mounted move', function () {
      const total = splide.length;
      const rate = (splide.index + 1) / total;
      bar.style.width = `${rate * 100}%`;
    });
  }

  splide.mount();

  slider.classList.add('splide--featured-initialized');
}

function autoInitFeaturedSliders(scope = document) {
  scope.querySelectorAll('.fps-splide').forEach((slider) => {
    initFeaturedSlider(slider);
  });
}

document.addEventListener('DOMContentLoaded', function () {
  autoInitFeaturedSliders();
});